import { render } from "./ParentMenuGroup.vue?vue&type=template&id=27dfb41d"
import script from "./ParentMenuGroup.vue?vue&type=script&lang=js"
export * from "./ParentMenuGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__